// extracted by mini-css-extract-plugin
export var container = "_84-0";
export var fallback = "_84-5";
export var fallbackIcon = "_84-6";
export var hidden = "_84-2";
export var image = "_84-3";
export var loaded = "_84-4";
export var placeholder = "_84-1";